import stateGo from 'redux-ui-router/lib/state-go';
import selectAction from './selectAction';
import {
  safeDeepDelete,
  escapeHTML,
} from '../../../../util/util';

export default function toggleAllSelectEvent(
  { dispatch, getRows },
  { key, parentSlug, wrapups = {} },
  evt
) {
  const { checked } = evt.target;
  // Use get rows to get the current rows in the slug, and build the new tree
  const active = getRows() || {};
  const keys = [...parentSlug.split('--'), 'all'];

  // If we've selected 'all', do an unsafe delete on the active
  // tree to ensure only {all: {}} exists in the tree.
  safeDeepDelete(keys.slice(0, -1), active, checked);

  const selected = selectWrapups(
    selectAction(active, keys, checked),
    checked,
    key,
    wrapups
  );

  dispatch(stateGo('datacenter.main', {
    selectedRows: Object.assign({}, selected),
  }));

  const event = new CustomEvent('selectAll', {
    detail: {
      parentSlug,
      checked,
      wrapups: getRelativeWrapups(wrapups, key),
    },
  });
  document.dispatchEvent(event);
  document.querySelector(`label[for="${key}"]`).innerHTML =
    escapeHTML(checked ? dcStrings.unselectAll : dcStrings.selectAll);

  return;
}

/**
 * Select wrapups from wrapup object
 * @param  {object} tree    [currently selected tree]
 * @param  {bool} select    [is currently selected]
 * @param  {string} key     [current key]
 * @param  {object} wrapups [wrapups on page]
 * @return {object}         [modified tree]
 */
function selectWrapups(tree, select, key, wrapups) {
  const relativeWrapups = getRelativeWrapups(wrapups, key);

  if (!select) {
    // All Unselected
    relativeWrapups.forEach((wrapup) => {
      ['wrapups', wrapup].reverse().some((itemKey, idx, arr) =>
        safeDeepDelete(
          [...arr.slice(idx + 1).reverse(), itemKey],
          tree,
          arr.length === 1
        )
      );
    });
    return tree;
  }
  // All select
  const wrapupTree = relativeWrapups.reduce((acc, wrapup) => {
    acc[wrapup] = {};
    return acc;
  }, {});
  const hasWrapUpTree = !!Object.keys(wrapupTree).length;
  return Object.assign(tree, hasWrapUpTree ? { wrapups: wrapupTree } : {});
}

/** Get relative wrapups based on key */
function getRelativeWrapups(wrapups, key) {
  return Object.keys(wrapups)
    .filter((wrapup) =>
      wrapup.indexOf(key.replace('-all', '')) > -1 // gotta remove that '-all' slug for matching...
    );
}



/** WEBPACK FOOTER **
 ** ../~/eslint-loader!./js/directives/refineColumns/children/events/toggleAllSelectEvent.js
 **/